import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';

const TableTab = ({ condition, selectedCondition, onConditionClick }) =>
  (<li>
    <a
      data-condition={condition}
      className={classNames({ active: condition === selectedCondition })}
      onClick={() => onConditionClick(condition)}
      title={I18n.t('js.transactionHistory.used')}
    >
      {I18n.t(`js.transactionHistory.${condition}`)}
    </a>
  </li>);

TableTab.propTypes = {
  condition: PropTypes.string.isRequired,
  selectedCondition: PropTypes.string.isRequired,
  onConditionClick: PropTypes.func.isRequired,
};

export default TableTab;



// WEBPACK FOOTER //
// ./javascripts/components/price_guide/transaction_history/table/tab.jsx